import './App.css';
import { Routes, Route } from "react-router-dom";
import GardenLayoutPage from "./components/GardenLayoutMainPage";
import GardenLayout from "./components/InGroundGardenDesigner";
import InGroundGardenGridPlanter from "./components/InGroundGardenGridPlanter";
import Dashboard from "./components/dashboardComponents/Dashboard";
import GardenManager from "./components/gardenManagerComponents/GardenManager";
import PlantFinderPage from "./components/plantFinderComponents/PlantFinderPage";
import AboutPage from "./components/aboutComponents/AboutPage";
import './css/ScrollbarStyling.css';

function App() {
    return (
        <Routes>
            <Route path="/" element={<GardenLayoutPage />} />
            <Route path="/in-ground-layout-page" element={<GardenLayout width={25} height={25} />} />
            <Route path="/garden-summary" element={<InGroundGardenGridPlanter />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/garden-manager" element={<GardenManager />} />
            <Route path="/plant-finder" element={<PlantFinderPage />} />
            <Route path="/about" element={<AboutPage />} />
        </Routes>
    );
}

export default App;